import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { ReactComponent as AppIconSvg } from '../../assets/icons/app-icon.svg';
import AppConfig from '../../config';
import FaIcon from '../global/fa-icon/fa-icon';
import PublishActions from '../../components/publish-actions/publish-actions.component';


class AppHeader extends Component {

  // NOTE: if you extend propTypes directly in child component class, you will get a react warning.  use _propTypes alias instead
  static propTypes = {
  };

  static defaultProps = {
  };


  constructor(props) {
    super(props);

    // NOTE: print out the app info data for testing.
    // console.log(JSON.stringify({ ...AppConfig.appInfo, env: AppConfig.env }, null, 2));

    this.state = {
      accountMenuOpen: false,
    };


    this.toggleAccountDropdownMenu = this.toggleAccountDropdownMenu.bind(this);
    this.navigateTo = this.navigateTo.bind(this);
  }

  toggleAccountDropdownMenu() {
    let accountMenuOpen = !this.state.accountMenuOpen;
    this.setState({ accountMenuOpen })
  }

  navigateTo(target) {
    this.setState({ accountMenuOpen: false });
    this.props.history.push(target);
  }

  render() {

    let isLoggedIn = this.props.auth.isLoggedIn;
    // console.log('header auth', this.props.auth);

    return (
      <div className="app-header d-flex flex-row justify-content-between align-items-center">
        <div className="app-title">
          <AppIconSvg className="svg-icon app-icon" />
          { AppConfig.title }
        </div>
        { isLoggedIn? (
          <React.Fragment>
            <div className="app-actions">
              <PublishActions />
            </div>
            <div className="auth-status-area account-menu d-flex dropdown">
              <div id="dropdownMenuLink" className="clickable"
                 data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"
                 onClick={this.toggleAccountDropdownMenu}>
                <div className="auth-status">
                  <div className="user-name">{ this.props.auth.profile.name }</div>
                  <FaIcon icon="fa-user-circle" />
                </div>
              </div>
              <div className={'dropdown-menu dropdown-menu-right ' + (this.state.accountMenuOpen? 'show': '')} aria-labelledby="dropdownMenuLink">
                <button className="dropdown-item" onClick={e => this.navigateTo('logout')}>
                  <FaIcon icon="fa-sign-out" />&nbsp;Sign out
                </button>
              </div>
            </div>
          </React.Fragment>
        ): null }
      </div>
    );
  }

}

function mapStateToProps(state) {
  return {
    auth: state.auth,
  };
}


const mapDispatchToProps = {
  // history
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(AppHeader));

